import React from 'react'
type Props = {
    classname?: string
}
function RegisterCustomerBlue({classname}: Props) {
  return (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" className={classname}>
  <image href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFaSURBVHgB5ZRBToNQEIZnXoF02RsUTyCtxsRdexLbjUpcGE+gnqC6QoyJ9AStJ6g7F0boEeoJdGl48MaZqqQmJKXajfFPgJl58z4mDG8A/q5ukwYEDy6sKCyNBonrKJqw5QLilDIz1JiOwd+dwapAK3jsoKqNeOEVDTwboIihe4jQqQL/BrSvk2MkugBD5/NATTXT/VZfzDpXnYPpLIMXQDtMBgDUY9iJ9rciJ3g6WwQuqhSem0vZZ0mCEyYjhnmUZV19tDOFJXrzWzN+RHIJ3IDpocJT8dVnjmdM3q8CK4Mz8P7LV5V3ym9UQRZUlK1hBGHs8fcaI+V36cH2uCyveoWSTDTEnLiRamCH8Uv9Jm7CTysUGYKp9tuR2E4YU+lLYc36h8CiKaiUx4OhWCA+dkimIcPiIwAN7oJb+Cydmxb7G4jWpiTMOXKzr+IJyqj6hRg304ftLqxb72KZmw+VpiIOAAAAAElFTkSuQmCC" width="20" height="20" />
</svg>
  )
}

export default RegisterCustomerBlue